<template>
  <div>
    <div class="max-w-sm">
      <Input
        :label="label"
        @change="input"
      />
    </div>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
import Input from '@/app/shared/components/form/inputs/input.vue';

export default {

  components: {
    Input,
  },

  props: {
    label: {
      type: String,
      default: 'Email',
    },
    required: {
      type: Boolean,
      default: false,
    },
    username: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      email: ' ',
    };
  },

  mounted() {
    // Trigger validation
    this.email = '';
    this.$emit('errors', this.getErrors());
  },

  methods: {
    input(input) {
      this.email = input;
      this.$emit('input', input);
      this.$emit('errors', this.getErrors());
    },

    getErrors() {
      const errors = [];

      if (this.required) {
        if (!this.$v.email.required) {
          errors.push('An email address is required.');
        }
      }

      if (this.email.includes('@') && !this.$v.email.email) {
        errors.push('Email address is not valid.');
      }

      return errors;
    },
  },

  validations() {
    return {
      email: {
        email,
        required,
      },
    };
  },
};
</script>
